import Table from '@/components/Table' 
import { PDVMarketResearch } from '@/types/MarketResearch' 
import { useMemo } from 'react'   
import { useTable } from '@/hooks/useTable'
import { createColumnHelper } from '@tanstack/react-table'
import { TableData } from '@/components/Table/type'
import DefaultColumn from '@/components/Table/components/DefaultColumn'
import DadosMestreHeaderActions from '@/pages/MasterData/components/DadosMestreHeaderActions'
import { usePDVInMarketResearchQuery } from '@/queries/usepdvInMarketResearchQuery'

export type PDVTable = TableData<PDVMarketResearch>

const columnHelper = createColumnHelper<PDVMarketResearch>()

interface props {
    id: number
}

const TablePDVMarketResearch = ({id}: props) => {   
    const { 
            tableState, 
            setTable
        } = useTable<PDVMarketResearch>('')

    const { data, isLoading, isFetching, refetch } = usePDVInMarketResearchQuery(Number(id))

    const memoData = useMemo(() => data || [], [data])
      const memoColumns = useMemo(
            () => [  
                columnHelper.accessor('NK_CLIENTE', {
                    id: 'NK_CLIENTE',
                    header: 'Cod. Cliente',
                    size: 120,
                }),  
                columnHelper.accessor('DS_NOME_FANTASIA', {
                    id: 'DS_NOME_FANTASIA',
                    header: 'Nome Fantasia',
                    size: 260,
                }),  
                columnHelper.accessor('DS_RAZAO_SOCIAL', {
                    id: 'DS_RAZAO_SOCIAL',
                    header: 'Razão Social',
                    size: 260,
                }), 
                columnHelper.accessor('DD_UF', {
                    id: 'DD_UF',
                    header: 'UF',
                    size: 80,
                }),  
                columnHelper.accessor('DS_CIDADE', {
                    id: 'DS_CIDADE',
                    header: 'Cidade',
                    size: 140,
                }),  
                columnHelper.accessor('DS_ENDERECO', {
                    id: 'DS_ENDERECO',
                    header: 'Endereço',
                    size: 180,
                }),  
                columnHelper.accessor('DS_BAIRRO', {
                    id: 'DS_BAIRRO',
                    header: 'Bairro',
                    size: 180,
                }),  
                columnHelper.accessor('DD_COMPLEMENTO', {
                    id: 'DD_COMPLEMENTO',
                    header: 'Complemento',
                    size: 130,
                }),  
                columnHelper.accessor('DD_NUMERO', {
                    id: 'DD_NUMERO',
                    header: 'Número',
                    size: 100,
                }),
                columnHelper.accessor('NM_FUNCIONARIO', {
                    id: 'NM_FUNCIONARIO',
                    header: 'Funcionário responsável da revenda',
                    size: 300,
                })
            ],
            []
        )

    return ( 
        <Table<PDVTable>
            data={memoData}
            columns={memoColumns}
            getRowId={(row) => row.SK_CLIENTE.toString()}
            isLoading={isLoading}
            isFetching={isFetching}
            getTableInstance={(table) => setTable(table)}   
            tableHeader 
            tableState={tableState}   
            tableActions={
                <DadosMestreHeaderActions
                    // onDownload={() => table && onDownload(table)}
                    onRefech={refetch} 
                />
            }  
            defaultColumn={{
                cell: ({ getValue }) => (
                    <DefaultColumn>{getValue() as string}</DefaultColumn>
                ),
            }}
        />  
    )
}

export default TablePDVMarketResearch
